import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default class RestoreDeletedBeatPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            limit: 10,
            deletedBeats: [],
            selectedBeats: [],
            loading: false,
            loadingRestore: false,
        };
    }

    handleUidChange = (e) => {
        this.setState({ uid: e.target.value });
    };

    handleLimitChange = (e) => {
        const value = e.target.value;
        // Chỉ cho phép nhập số dương
        if (value === "" || (!isNaN(value) && parseInt(value) > 0)) {
            this.setState({ limit: value === "" ? "" : parseInt(value) });
        }
    };

    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.loadDeletedBeats();
        }
    };

    loadDeletedBeats = () => {
        const { uid, limit } = this.state;
        
        if (!uid || !uid.trim()) {
            toast.warning("Vui lòng nhập UID");
            return;
        }

        if (!limit || limit <= 0) {
            toast.warning("Limit phải lớn hơn 0");
            return;
        }

        this.setState({ loading: true, deletedBeats: [], selectedBeats: [] });

        axios
            .post(
                `${global.config.apiDomain}/mc-recording/web/get-deleted-beats`,
                { 
                    uid: parseInt(uid.trim()),
                    limit: parseInt(limit)
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data && res.data.status === "OK") {
                    const beats = res.data.data || [];
                    this.setState({ deletedBeats: beats });
                    if (beats.length === 0) {
                        toast.info("Không tìm thấy beat đã xóa nào");
                    } else {
                        toast.success(`Đã tìm thấy ${beats.length} beat đã xóa`);
                    }
                } else {
                    toast.error(res.data?.message || "Đã xảy ra lỗi khi tải danh sách beat đã xóa");
                    this.setState({ deletedBeats: [] });
                }
            })
            .catch((error) => {
                this.setState({ loading: false, deletedBeats: [] });
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Đã xảy ra lỗi khi tải danh sách beat đã xóa";
                toast.error(errorMessage);
                console.error("Load deleted beats error:", error);
            });
    };

    handleCheckboxChange = (beatId) => {
        const { selectedBeats } = this.state;
        const index = selectedBeats.indexOf(beatId);
        
        if (index > -1) {
            // Bỏ chọn
            this.setState({
                selectedBeats: selectedBeats.filter((id) => id !== beatId),
            });
        } else {
            // Chọn
            this.setState({
                selectedBeats: [...selectedBeats, beatId],
            });
        }
    };

    handleSelectAll = (e) => {
        const { deletedBeats, selectedBeats } = this.state;
        const isChecked = e.target.checked;
        
        if (isChecked) {
            // Chọn tất cả
            const allIds = deletedBeats.map((beat) => beat.id || beat._id);
            this.setState({ selectedBeats: allIds });
        } else {
            // Bỏ chọn tất cả
            this.setState({ selectedBeats: [] });
        }
    };

    handleRestoreSelected = () => {
        const { selectedBeats } = this.state;
        
        if (selectedBeats.length === 0) {
            toast.warning("Vui lòng chọn ít nhất một beat để khôi phục");
            return;
        }

        this.setState({ loadingRestore: true });

        axios
            .post(
                `${global.config.apiDomain}/mc-recording/web/restore-recordings`,
                { recordingIds: selectedBeats },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                this.setState({ loadingRestore: false, selectedBeats: [] });
                if (res.data && res.data.status === "OK") {
                    const message = res.data.data || res.data.message || "Khôi phục beat thành công";
                    toast.success(message);
                    // Load lại danh sách beat đã xóa
                    this.loadDeletedBeats();
                } else {
                    toast.error(res.data?.message || "Đã xảy ra lỗi khi khôi phục beat");
                }
            })
            .catch((error) => {
                this.setState({ loadingRestore: false });
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Đã xảy ra lỗi khi khôi phục beat";
                toast.error(errorMessage);
                console.error("Restore beats error:", error);
            });
    };

    formatDate = (timestamp) => {
        if (!timestamp) return "-";
        const date = new Date(timestamp);
        return date.toLocaleDateString("vi-VN");
    };

    formatTime = (timestamp) => {
        if (!timestamp) return "-";
        const date = new Date(timestamp);
        return date.toLocaleTimeString("vi-VN");
    };

    render() {
        const {
            uid,
            limit,
            deletedBeats,
            selectedBeats,
            loading,
            loadingRestore,
        } = this.state;

        const allSelected =
            deletedBeats.length > 0 &&
            deletedBeats.every(
                (beat) =>
                    selectedBeats.includes(beat.id || beat._id)
            );

        return (
            <div
                className="container-fluid"
                style={{ marginTop: "100px", marginBottom: "20px" }}
            >
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-rotate-left mr-2"></i>
                                    Khôi phục beat đã xóa
                                </h3>
                            </div>
                            <div className="card-body">
                                {/* Form nhập UID và Limit */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="uid">
                                                <strong>UID *</strong>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="uid"
                                                name="uid"
                                                value={uid}
                                                onChange={this.handleUidChange}
                                                onKeyPress={this.handleKeyPress}
                                                placeholder="Nhập UID của user"
                                                disabled={loading || loadingRestore}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="limit">
                                                <strong>Limit *</strong>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="limit"
                                                name="limit"
                                                value={limit}
                                                onChange={this.handleLimitChange}
                                                onKeyPress={this.handleKeyPress}
                                                placeholder="Số lượng beat (mặc định: 10)"
                                                min="1"
                                                disabled={loading || loadingRestore}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>&nbsp;</label>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-block"
                                                onClick={this.loadDeletedBeats}
                                                disabled={loading || loadingRestore}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm mr-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Đang tải...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa-solid fa-search mr-2"></i>
                                                        Load
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Nút Restore Selected */}
                                {deletedBeats.length > 0 && (
                                    <div className="mb-3">
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={this.handleRestoreSelected}
                                            disabled={loadingRestore || selectedBeats.length === 0}
                                        >
                                            {loadingRestore ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm mr-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Đang khôi phục...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-rotate-left mr-2"></i>
                                                    Restore Selected ({selectedBeats.length})
                                                </>
                                            )}
                                        </button>
                                    </div>
                                )}

                                {/* Bảng danh sách beat đã xóa */}
                                {deletedBeats.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-hover table-bordered">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col" style={{ width: "50px" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={allSelected}
                                                            onChange={this.handleSelectAll}
                                                            disabled={loadingRestore}
                                                        />
                                                    </th>
                                                    <th scope="col">Tên</th>
                                                    <th scope="col">Thể loại</th>
                                                    <th scope="col">Ngày xóa</th>
                                                    <th scope="col">Giờ xóa</th>
                                                    <th scope="col">Xóa bởi ai</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {deletedBeats.map((beat, index) => {
                                                    const beatId = beat.id || beat._id;
                                                    const isSelected = selectedBeats.includes(beatId);
                                                    
                                                    return (
                                                        <tr key={beatId || index}>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isSelected}
                                                                    onChange={() =>
                                                                        this.handleCheckboxChange(beatId)
                                                                    }
                                                                    disabled={loadingRestore}
                                                                />
                                                            </td>
                                                            <td>{beat.songName || "-"}</td>
                                                            <td>{beat.performanceType || "-"}</td>
                                                            <td>
                                                                {this.formatDate(beat.deleteTime)}
                                                            </td>
                                                            <td>
                                                                {this.formatTime(beat.deleteTime)}
                                                            </td>
                                                            <td>
                                                                {beat.deleteBy 
                                                                    ? `${beat.deleteBy} (UID: ${beat.deleteUser || "-"})`
                                                                    : beat.deleteUser || "-"}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    !loading && (
                                        <div className="text-center py-4">
                                            <p className="text-muted">
                                                {uid
                                                    ? "Không có beat đã xóa nào"
                                                    : "Vui lòng nhập UID và nhấn Load để tìm kiếm"}
                                            </p>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
